import { useState, useEffect } from 'react'
import { Spin } from 'antd'
import { manualFetch } from 'src/utils/fetch'

interface PrivateVideoProps {
  src: string | null
  className?: string
}

export default function PrivateVideo({
  src,
  className,
}: PrivateVideoProps): JSX.Element {
  const [url, setUrl] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!src) {
      setUrl('')
      return
    }
    if (src.startsWith('blob:') || src.startsWith('data:')) {
      setUrl(src)
      return
    }

    let objectUrl: string | null = null
    setLoading(true)
    manualFetch(src, { headers: { accept: 'video/*' } })
      .then((response) => response.blob())
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob)
        setUrl(objectUrl)
        setLoading(false)
      })
      .catch(() => setLoading(false))

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [src])

  if (loading) {
    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin />
      </div>
    )
  }

  return <video className={className} src={url} controls />
}
